"use strict";

var _Object$defineProperty = require("babel-runtime/core-js/object/define-property")["default"];

exports["default"] = function (obj, key, value) {
  if (key in obj) {
    _Object$defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

exports.__esModule = true;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-relay/~/babel-runtime/helpers/define-property.js
 ** module id = 160
 ** module chunks = 0
 **/